$w.onReady(function () {
	$w('#headerLogo').show("fade", {"duration": 600, "delay": 0 })
});